import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/Table/TableDetailValue/TableDetailValue.styles';
import { NOT_FOUND_VALUE } from 'features/EntityDetails/components/EntityDetails/EntityDetail/components/EntityDetailValue';
import { truncateText } from 'utils/truncateText';

type TableDetailValueProps = {
  value: string | null;
  isExpanded?: boolean;
  characterLimit?: number;
};

const TableDetailValue = ({ value, isExpanded, characterLimit }: TableDetailValueProps) => {
  const classes = useStyles();
  return (
    <Typography
      fontWeight={isExpanded && 600}
      variant="body2"
      className={!value ? classes.notFoundValue : undefined}
    >
      {truncateText(value || NOT_FOUND_VALUE, characterLimit)}
    </Typography>
  );
};

export default TableDetailValue;
